import React, {Component, Suspense} from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import utils from "./util/util";

const Workspace = React.lazy(() => import("./components/pages/Workspace"));
const Home = React.lazy(() => import("./components/pages/Home"));
const Confirm = React.lazy(() => import("./components/pages/Confirm"));
const Auth = React.lazy(() => import("./components/pages/Auth"));
const Account = React.lazy(() => import("./components/pages/Account"));
const SignArchive = React.lazy(() => import("./components/pages/SignArchive"));
const Handle = React.lazy(() => import("./components/pages/Handle"));
const InvoiceHistory = React.lazy(() => import("./components/pages/InvoiceHistory"));
const PublisherSubscribe = React.lazy(() => import("./components/pages/PublisherSubscribe"));

export default {
    getRoutes(includeMainApp) {

        //to simplify some of the weird routing around handles, it's easier just to only serve that page on handle routes.
        //If we do this more often it might need to be more robust.
        let isHandlePage = utils.isHandleUrl(window.location.pathname);
        if(isHandlePage) {
            return (
              <Suspense fallback={<div></div>}>
                <Routes>
                  <Route index element={<Handle />} />
                </Routes>
              </Suspense>
            )
        }

        return (
          <Suspense fallback={<div></div>}>
            <Routes>
                <Route path="/" element={<Auth/>}/>
                <Route path="/confirm" element={<Confirm/>}/>
                <Route path="/publisher_subscribe" element={<PublisherSubscribe/>}/>

                {includeMainApp && <Route path="/home" element={<Home/>}/>}
                {includeMainApp && <Route path="/account" element={<Account/>}/>}
                {includeMainApp && <Route path="/sign_archive" element={<SignArchive/>}/>}
                {includeMainApp && <Route path="/invoice_history" element={<InvoiceHistory/>}/>}
                {includeMainApp && <Route path="/workspace/:forum_id" element={<Workspace/>}/>}

                <Route path='/*' element={<Navigate to={'/'} replace={true}/>} />
            </Routes>
          </Suspense>
        )
    }
}
